import AbstractAdapter from 'adapters/AbstractAdapter';
import LocalStorage from 'adapters/LocalStorage';
import _ from 'lodash';

_.noConflict();


export default class StorageAdapter extends AbstractAdapter {
  constructor (storageName, fieldsParams) {
    super(fieldsParams);
    this.storageName = storageName;
    this.localStorageRegistry = {};
  }

  getStorageValue (name) {
    let value = sessionStorage.getItem(name);
    if (value) {
      return JSON.parse(value);
    }

    let localStorageModel = this.localStorageRegistry[name];
    if (!localStorageModel) {
      localStorageModel = new LocalStorage({id: name});
      this.localStorageRegistry[name] = localStorageModel;
    }

    value = localStorageModel.attributes;

    // We return value if json is not empty.
    if (!_.isEmpty(value)) {
      return value;
    }
  }

  setStorageValue (name, value, options) {
    options = options || {};
    sessionStorage.setItem(name, JSON.stringify(value));

    if (options.storeAppOnly) {
      return;
    }

    let localStorageModel = this.localStorageRegistry[name];
    if (localStorageModel) {
      localStorageModel.clear({silent: !_.isEmpty(value)}).set(value);
    } else {
      localStorageModel = new LocalStorage({id: name});
      this.localStorageRegistry[name] = localStorageModel;
      localStorageModel.save(value);
    }

    return this;
  }

  loadStore () {
    this.store = this.getStorageValue(this.storageName) || {};
  }

  saveStore () {
    this.setStorageValue(this.storageName, this.store);
  }
}
